<template>
  <div class="p-grid p-col-12" v-if="protocol.id">
    <div class="p-col-12">
      <h1 class="float-left p-mt-2 p-mr-3">
        {{protocolName(protocol)}}
        <a v-if="loggedUser.typeUser !== limited" class="cursor-pointer" :href="`#/protocol/form/${protocol.id}`"><i class="p-ml-2 pi pi-pencil" :title="$t('protocol.edit')"/></a>
      </h1>
      <ancestryline-tab class="float-left" :tabs="tabs"/>
    </div>
    <component :key="currentTab" :is="getComponent" :protocol="protocol"/>
  </div>
</template>

<script>

import AncestrylineTab from "@/components/tab/AncestrylineTab";
import TabServicesProtocol from "@/viewer/protocol/tabs/TabServicesProtocol";
import TabGeneralProtocol from "@/viewer/protocol/tabs/TabGeneralProtocol";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import EventBus from "@/commons/EventBus";
import TabChecklistProtocol from "@/viewer/protocol/tabs/TabChecklistProtocol";
import TabFinancialProtocol from "@/viewer/protocol/tabs/TabFinancialProtocol";
import TabTimelineProtocol from "@/viewer/protocol/tabs/TabTimelineProtocol";
import store from "@/store";
import {LIMITED, NORMAL} from "@/constants/TypeUser";
import {permissionsLevel} from "@/router";
import FrontBusiness from "@/business/FrontBusiness";

export default {
  name: "Protocol",
  components: {AncestrylineTab},

  async beforeMount() {
    EventBus.loadingPage(true);
    this.protocol = await ProtocolBusiness.getById(this.$route.params.id);
    EventBus.loadingPage(false);
  },

  computed: {
    getComponent(){
      switch (this.currentTab){
        case 'services': return TabServicesProtocol;
        case 'checklist': return TabChecklistProtocol;
        case 'timeline': return TabTimelineProtocol;
        case 'financial': {
            if (permissionsLevel[this.loggedUser.typeUser].includes(NORMAL)) {
                return TabFinancialProtocol;
            } else {
                return FrontBusiness.redirect(`/protocol/${this.protocol.id}`);
            }
        }
        default: return TabGeneralProtocol;
      }
    },
    tabs(){
      const tabs = [
          {
              label: this.$t('protocol.tabs.general'),
              to: `/protocol/${this.protocol.id}`
          },
          {
              label: this.$t('protocol.tabs.services'),
              to: `/protocol/${this.protocol.id}/services`
          },
          {
              label: this.$t('protocol.tabs.checklist'),
              to: `/protocol/${this.protocol.id}/checklist`
          }
          ,
          {
              label: this.$t('protocol.tabs.timeline'),
              to: `/protocol/${this.protocol.id}/timeline`
          }
      ];
      if (permissionsLevel[this.loggedUser.typeUser].includes(NORMAL)) {
          tabs.push(
              {
                  label: this.$t('protocol.tabs.financial'),
                  to: `/protocol/${this.protocol.id}/financial`
              }
          );
      }
      return tabs;
    },
    currentTab(){
      return this.$route.params.tab || 'general';
    }
  },

  data(){
    return {
      limited: LIMITED,
      loggedUser: store.getLoggedUser(),
      loading: true,
      protocol: {type: Object, default: {}},
    }
  },

  methods:{
    protocolName: ProtocolBusiness.protocolName,
  }

}
</script>

<style scoped>

</style>